import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, Typography } from "@mui/material";
import InfoTooltip from "../../../common_components/InfoTooltip";
import { StyledCurrency } from "../../../helper/StyledCurrency";
import { formatStat } from "../../../helper/statsFormatter";
/**
 * Figma tokens — the same set the Commission Tracker Report stat cards use, so the
 * two pages read as one system: a small 12px muted label above an 18px semibold
 * value with a lighter currency symbol.
 */
const CARD_BORDER = "#D4D4D8"; // zinc/300
const ICON_COLOR = "#667085";
/**
 * The Billing Summary KPI row — 8 cards laid out 4-up, collapsing to 2-up on
 * tablets and 1-up on phones.
 *
 * The card shell is written out here rather than pulled from the tracker report:
 * that page's version is a Figma side-by-side that is slated for deletion, and its
 * labels are single-word/nowrap. Billing's labels are long ("# of Clients Remaining
 * to Collect"), so they wrap instead of being clipped — the only deviation.
 */
const BillingSummaryCards = ({ cards, heading }) => (_jsxs(Box, { sx: {
        bgcolor: "#fff",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
    }, children: [_jsx(Typography, { className: "all-Font-Sizes-14", sx: { fontSize: "14px !important", fontWeight: 600, color: "#101828", textAlign: "center" }, children: heading }), _jsx(Box, { sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, minmax(0, 1fr))",
                    lg: "repeat(4, minmax(0, 1fr))",
                },
                gap: "10px",
                alignItems: "stretch",
            }, children: cards.map((card) => (_jsxs(Paper, { elevation: 0, sx: {
                    minWidth: 0,
                    bgcolor: "#fff",
                    border: `1px solid ${CARD_BORDER}`,
                    borderRadius: "8px",
                    p: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: "10px",
                }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "flex-start", gap: "5px" }, children: [_jsx(Box, { sx: { color: ICON_COLOR, display: "flex", flexShrink: 0, mt: "1px" }, children: card.icon }), _jsx(Typography, { className: "all-Font-Sizes-14", sx: { fontSize: "14px !important", lineHeight: "20px", fontWeight: 500, color: "#475467" }, children: card.title }), _jsx(InfoTooltip, { title: _jsx(Box, { className: "all-Font-Sizes-12", sx: { p: 0.5 }, children: card.tooltip }), placement: "top", size: 14, sx: { mt: "2px" } })] }), _jsx(Box, { sx: { display: "flex", alignItems: "center", height: 28 }, children: _jsx(StyledCurrency, { value: formatStat(card.value, card.format), fontSize: "14px", symbolSize: "14px", valueWeight: 700, symbolWeight: 400, valueColor: "#101828", symbolColor: "#98A2B3" }) })] }, card.key))) })] }));
export default BillingSummaryCards;
